export const AuthType = {
  Sso: "sso",
  OAuth: "oauth",
} as const

export type TAuthType = (typeof AuthType)[keyof typeof AuthType]

export function getAuthType(authTypeParam: string | null): TAuthType {
  switch (authTypeParam) {
    case "oauth":
      return AuthType.OAuth
    case "sso":
    default:
      return AuthType.Sso
  }
}
